
if (!customElements.get('product-form')) {
  customElements.define(
    'product-form',
    class ProductForm extends HTMLElement {
      constructor() {
        super();

        this.form = this.querySelector('form');
        this.variantIdInput.disabled = false;

        this.form.addEventListener(
          'submit',
          this.onSubmitHandler.bind(this)
        );

        this.cart =
          document.querySelector('cart-notification') ||
          document.querySelector('cart-drawer');

        this.submitButton = this.querySelector('[type="submit"]');
        this.submitButtonText = this.submitButton.querySelector('span');

        if (document.querySelector('cart-drawer')) {
          this.submitButton.setAttribute('aria-haspopup', 'dialog');
        }

        this.hideErrors = this.dataset.hideErrors === 'true';

        // Upsell error state
        this.error = false;
        this.upsellCartError = false;

        // Listen for upsell checkbox changes
        this.handleUpsellCheckboxChange =
          this.handleUpsellCheckboxChange.bind(this);

        document.addEventListener(
          'change',
          this.handleUpsellCheckboxChange
        );
      }

      async onSubmitHandler(evt) {
        evt.preventDefault();

        if (
          this.submitButton.getAttribute('aria-disabled') === 'true' ||
          this.submitButton.disabled
        ) {
          return;
        }

        this.handleErrorMessage();

        this.error = false;
        this.upsellCartError = false;

        // Start loading spinner
        this.submitButton.setAttribute('aria-disabled', true);
        this.submitButton.classList.add('loading');

        const spinner = this.querySelector('.loading__spinner');

        if (spinner) {
          spinner.classList.remove('hidden');
        }

        const formData = new FormData(this.form);

        // Main product
        const mainItem = {
          id: Number(formData.get('id')),
          quantity: Number(formData.get('quantity') || 1)
        };

        // Preserve main product properties
        const properties = {};

        formData.forEach((value, key) => {
          const match = key.match(/^properties\[(.+)\]$/);

          if (match) {
            properties[match[1]] = value;
          }
        });

        if (Object.keys(properties).length) {
          mainItem.properties = properties;
        }

        // Preserve selling plan
        const sellingPlan = formData.get('selling_plan');

        if (sellingPlan) {
          mainItem.selling_plan = sellingPlan;
        }

        // Collect checked upsell products
        const checkedUpsells = document.querySelectorAll(
          '.upsell-product input[type="checkbox"]:checked'
        );

        const items = [mainItem];

        checkedUpsells.forEach((checkbox) => {
          const variantId = Number(checkbox.value);

          if (variantId) {
            items.push({
              id: variantId,
              quantity: 1
            });
          }
        });

        // Configure Shopify AJAX request
        const config = fetchConfig('javascript');

        config.headers['X-Requested-With'] = 'XMLHttpRequest';
        config.headers['Content-Type'] = 'application/json';

        const requestData = {
          items: items
        };

        // Request cart drawer sections
        if (this.cart) {
          requestData.sections = this.cart
            .getSectionsToRender()
            .map((section) => section.id);

          requestData.sections_url = window.location.pathname;

          this.cart.setActiveElement(document.activeElement);
        }

        config.body = JSON.stringify(requestData);

        try {
          const response = await fetch(
            routes.cart_add_url,
            config
          );

          const responseData = await response.json();

          // Handle Shopify errors
          if (!response.ok || responseData.status) {
            publish(PUB_SUB_EVENTS.cartError, {
              source: 'product-form',
              productVariantId: formData.get('id'),
              errors:
                responseData.errors ||
                responseData.description,
              message: responseData.message
            });

            const errorMessage =
              responseData.description ||
              responseData.message ||
              'Unable to add products to cart.';

            this.handleErrorMessage(errorMessage);

            this.error = true;

            // Track whether upsells were included
            this.upsellCartError = items.length > 1;

            // Show native sold-out message only for main product errors
            if (items.length === 1) {
              const soldOutMessage = this.submitButton.querySelector(
                '.sold-out-message'
              );

              if (soldOutMessage) {
                this.submitButtonText.classList.add('hidden');
                soldOutMessage.classList.remove('hidden');
              }
            }

            return;
          }

          // Redirect if cart drawer is unavailable
          if (!this.cart) {
            window.location = window.routes.cart_url;
            return;
          }

          // Plasticare cart rebalance functionality
          if (window.PlasticareCutMinimum?.rebalance && this.cart) {
            const sectionIds = this.cart
              .getSectionsToRender()
              .map((section) => section.id);

            const rebalanced =
              await window.PlasticareCutMinimum.rebalance({
                sections: sectionIds,
                sectionsUrl: window.location.pathname
              });

            if (rebalanced?.sections) {
              responseData.sections = rebalanced.sections;
            }
          }

          // Publish cart update
          const startMarker =
            CartPerformance.createStartingMarker(
              'add:wait-for-subscribers'
            );

          if (!this.error) {
            publish(PUB_SUB_EVENTS.cartUpdate, {
              source: 'product-form',
              productVariantId: formData.get('id'),
              cartData: responseData
            }).then(() => {
              CartPerformance.measureFromMarker(
                'add:wait-for-subscribers',
                startMarker
              );
            });
          }

          this.error = false;
          this.upsellCartError = false;

          // Open and render cart drawer
          const quickAddModal = this.closest('quick-add-modal');

          if (quickAddModal) {
            document.body.addEventListener(
              'modalClosed',
              () => {
                setTimeout(() => {
                  CartPerformance.measure(
                    'add:paint-updated-sections',
                    () => {
                      this.cart.renderContents(responseData);
                    }
                  );
                });
              },
              { once: true }
            );

            quickAddModal.hide(true);

          } else {
            CartPerformance.measure(
              'add:paint-updated-sections',
              () => {
                this.cart.renderContents(responseData);
              }
            );
          }

          // Preserve custom product form functionality
          if ($('.custom-product-template').length > 0) {
            const resetCustomForm = new Event('resetCustomForm');
            document.dispatchEvent(resetCustomForm);
          }

        } catch (error) {
          console.error('Add to cart error:', error);

          this.error = true;
          this.upsellCartError = items.length > 1;

          this.handleErrorMessage(
            'Something went wrong. Please try again.'
          );

        } finally {
          // Stop loading spinner
          this.submitButton.classList.remove('loading');

          if (this.cart && this.cart.classList.contains('is-empty')) {
            this.cart.classList.remove('is-empty');
          }

          if (!this.error) {
            this.submitButton.removeAttribute('aria-disabled');
          }

          if (spinner) {
            spinner.classList.add('hidden');
          }

          CartPerformance.measureFromEvent(
            'add:user-action',
            evt
          );
        }
      }

      // Reset error when an upsell product is unchecked
      handleUpsellCheckboxChange(event) {
        const checkbox = event.target;

        if (
          !checkbox.matches(
            '.upsell-product input[type="checkbox"]'
          )
        ) {
          return;
        }

        // Only handle deselection after an upsell cart error
        if (!this.error || !this.upsellCartError || checkbox.checked) {
          return;
        }

        // Reset error state
        this.error = false;
        this.upsellCartError = false;

        // Remove error message
        this.handleErrorMessage(false);

        // Hide sold-out message
        const soldOutMessage = this.submitButton.querySelector(
          '.sold-out-message'
        );

        if (soldOutMessage) {
          soldOutMessage.classList.add('hidden');
        }

        // Restore button text
        if (this.submitButtonText) {
          this.submitButtonText.classList.remove('hidden');
          this.submitButtonText.textContent =
            window.variantStrings.addToCart;
        }

        // Reactivate Add to Cart button
        this.submitButton.removeAttribute('aria-disabled');
      }

      handleErrorMessage(errorMessage = false) {
        if (this.hideErrors) return;

        this.errorMessageWrapper =
          this.errorMessageWrapper ||
          this.querySelector(
            '.product-form__error-message-wrapper'
          );

        if (!this.errorMessageWrapper) return;

        this.errorMessage =
          this.errorMessage ||
          this.errorMessageWrapper.querySelector(
            '.product-form__error-message'
          );

        this.errorMessageWrapper.toggleAttribute(
          'hidden',
          !errorMessage
        );

        if (errorMessage && this.errorMessage) {
          this.errorMessage.textContent = errorMessage;
        }
      }

      toggleSubmitButton(disable = true, text) {
        if (disable) {
          this.submitButton.setAttribute('disabled', 'disabled');

          if (text) {
            this.submitButtonText.textContent = text;
          }

        } else {
          this.submitButton.removeAttribute('disabled');

          this.submitButtonText.textContent =
            window.variantStrings.addToCart;
        }
      }

      get variantIdInput() {
        return this.form.querySelector('[name=id]');
      }
    }
  );
}
